import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, reactive, ref } from 'vue';
import apis from "@/api";
import _ from 'lodash';
export default {
  __name: 'MoreUpload',
  props: {
    title: {
      type: String,
      default: '文件上传',
      required: false
    },
    /** 嵌套在其他 el-dialog 内时建议传入更高值，避免被遮挡 */
    zIndex: {
      type: Number,
      default: 4100
    },
    visible: {
      type: Boolean,
      default: false
    },
    fileTypes: {
      type: Array,
      default: () => {
        return ['image/jpeg', 'image/png', 'image/gif'];
      },
      required: false
    },
    fileSize: {
      type: Number,
      default: 10,
      //单位MB
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    buckets: {
      type: String,
      default: null
    }
  },
  emits: ['uploadSuccess', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const dialogZIndex = computed(() => props.zIndex);
    const emits = __emit;
    const data = reactive({
      fileList: []
    });
    const fileLoading = ref(false);
    const submitUpload = () => {
      if (!data.fileList || data.fileList.length == 0) {
        ElMessage.error('请先选取文件');
        return;
      }
      fileLoading.value = true;
      let formData = new FormData();
      data.fileList.forEach(f => {
        formData.append('fileList', f);
      });
      formData.append('bucketName', 'outer-for-inner');
      apis.upload(formData).then(res => {
        console.log("upload-res: ", res);
        if (res && res.success) {
          emits('uploadSuccess', res.data);
          ElMessage.success('文件上传成功');
        } else {
          ElMessage.error('文件上传失败:' + res.msg);
        }
        fileLoading.value = false;
      }).catch(err => {
        console.log("err", err);
        ElMessage.error('文件上传失败');
        fileLoading.value = false;
      });
    };
    const uploadFiles = params => {
      data.fileList.push(params.file);
    };
    const beforeUpload = rawFile => {
      // const index = _.findIndex(props.fileTypes, (type) => {
      //   return type === rawFile.type
      // })
      // if (index === -1) {
      //   ElMessage.error('文件类型不支持:' + rawFile.type)
      //   return false
      // }
      // if (rawFile.size / 1024 / 1024 > props.fileSize) {
      //   ElMessage.error('文件大小超出限制')
      //   return false
      // }
      return true;
    };
    const close = () => {
      data.fileList = [];
      emits('update:visible', false);
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        width: "30%",
        title: __props.title,
        "model-value": __props.visible,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        "append-to-body": "",
        "z-index": dialogZIndex.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          multiple: __props.multiple,
          "http-request": uploadFiles,
          "file-list": data.fileList,
          "before-upload": beforeUpload
        }, {
          trigger: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("选取文件", -1)]))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "btn-right",
            type: "success",
            onClick: submitUpload,
            loading: fileLoading.value
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("上传", -1)]))]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        }, 8, ["multiple", "file-list"])]),
        _: 1
      }, 8, ["title", "model-value", "z-index"]);
    };
  }
};